import script from "./SurveyFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyFormView.vue?vue&type=script&setup=true&lang=js"

import "./SurveyFormView.vue?vue&type=style&index=0&id=29dd4fc6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29dd4fc6"]])

export default __exports__